module.exports = __webpack_public_path__ + "f16d06d9df109aec232ce99ff6559aba.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/furnitures/floor_items/wand.png
// module id = 1590
// module chunks = 0